define('modules/editor/models/property_groups/page_jquery_selector',['require','exports','module','./base','common/jquery/config'],function(require,exports,module){
  "use strict";

  var BasePropertyGroup = require("./base"),
      jQueryConfig = require("common/jquery/config"),
      jQueryLatest = jQueryConfig.getLatest();

  module.exports = BasePropertyGroup.extend({
    name: 'page:jquery_selector',
    properties: ['version', 'successMessage'],
    defaults: {
      version: jQueryLatest.version,
      url: jQueryLatest.url,
      successMessage: '',
    }
  });
});

